/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/mute-1214309': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12.43 4.1a1 1 0 00-1 .12L6.65 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3.65l4.73 3.78A1 1 0 0012 20a.91.91 0 00.43-.1A1 1 0 0013 19V5a1 1 0 00-.57-.9zM11 16.92l-3.38-2.7A1 1 0 007 14H4v-4h3a1 1 0 00.62-.22L11 7.08zM19.91 12l1.8-1.79a1 1 0 00-1.42-1.42l-1.79 1.8-1.79-1.8a1 1 0 00-1.42 1.42l1.8 1.79-1.8 1.79a1 1 0 000 1.42 1 1 0 001.42 0l1.79-1.8 1.79 1.8a1 1 0 001.42 0 1 1 0 000-1.42z"/>'
  }
})
